var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96735 8.46094H7.7179C7.5264 8.46106 7.34092 8.5278 7.19329 8.64974C7.04567 8.77167 6.945 8.94117 6.90868 9.12917C6.87236 9.31718 6.9026 9.512 6.99417 9.68015C7.08574 9.8483 7.233 9.97939 7.41061 10.0509L8.67911 10.5585C8.85673 10.63 9.00398 10.7611 9.09555 10.9292C9.18713 11.0974 9.21736 11.2922 9.18104 11.4802C9.14472 11.6682 9.04405 11.8377 8.89643 11.9596C8.7488 12.0816 8.56332 12.1483 8.37182 12.1484H7.1236",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0459 8.46094V8",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0459 12.6094V12.1484",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81934 5.69531H11.2725",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2314 3.71999L11.1151 1.95245C11.1584 1.86594 11.1732 1.76804 11.1577 1.67261C11.1422 1.57717 11.097 1.48903 11.0287 1.42066C10.9603 1.35229 10.8721 1.30716 10.7767 1.29163C10.6813 1.27611 10.5834 1.291 10.4969 1.33418L9.32917 1.91681C9.22868 1.96696 9.11339 1.97871 9.00485 1.94985C8.89632 1.921 8.80204 1.85352 8.73978 1.76009L8.43065 1.29116C8.38855 1.22803 8.33151 1.17627 8.26465 1.14047C8.19772 1.10467 8.12305 1.08594 8.04715 1.08594C7.97124 1.08594 7.89657 1.10467 7.82964 1.14047C7.76278 1.17627 7.70574 1.22803 7.66365 1.29116L7.35082 1.76009C7.28863 1.85362 7.19435 1.92119 7.08581 1.95005C6.97722 1.97891 6.86186 1.96709 6.76143 1.91681L5.59557 1.33418C5.50903 1.2912 5.41119 1.27646 5.31583 1.29204C5.22048 1.30762 5.13242 1.35274 5.06406 1.42103C4.9957 1.48931 4.9505 1.57733 4.93483 1.67267C4.91915 1.76801 4.93379 1.86587 4.97668 1.95245L5.84324 3.68558",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07274 7.07812L3.37649 9.04479C2.9614 9.58433 2.70568 10.2293 2.63828 10.9068C2.57088 11.5842 2.69448 12.2669 2.9951 12.8777C3.29573 13.4885 3.76136 14.0029 4.33927 14.3627C4.91718 14.7224 5.58428 14.9133 6.26503 14.9134H9.82347C10.5042 14.9133 11.1713 14.7224 11.7492 14.3627C12.3272 14.0029 12.7928 13.4885 13.0934 12.8777C13.394 12.2669 13.5176 11.5842 13.4502 10.9068C13.3828 10.2293 13.1271 9.58433 12.712 9.04479L11.0158 7.07812",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.2a43410e4303044ce74bf822e89e31d3.svg";
export { ForwardRef as ReactComponent };